const loadInsightsOverviewBundle = () => import(
  /* webpackChunkName: "insights-overview" */ '../screens/InsightsOverviewRouteBundle'
);
const loadInsightsDebtBundle = () => import(
  /* webpackChunkName: "insights-debt" */ '../screens/InsightsDebtRouteBundle'
);

const loadRoute = (loadBundle, exportName) => loadBundle().then((routeModule) => ({
  default: routeModule[exportName],
}));

export const loadInsightsScreen = () => loadRoute(loadInsightsOverviewBundle, 'InsightsScreen');
export const loadInsightsDebtOptimizerScreen = () => (
  loadRoute(loadInsightsDebtBundle, 'InsightsDebtOptimizerScreen')
);
export const loadInsightsMobileScreen = () => (
  loadRoute(loadInsightsOverviewBundle, 'InsightsMobileScreen')
);
export const loadInsightsDebtOptimizerMobileScreen = () => (
  loadRoute(loadInsightsDebtBundle, 'InsightsDebtOptimizerMobileScreen')
);
